import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CardPedido from "../CardPedido";
import './index.css';
import { api } from '../../services/api';
import Menu from '../../comum/Menu/index.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { Modal, Button } from 'react-bootstrap';
import RefeicaoPDF from "../RefeicaoPDF/index.jsx";

const fotosCache = new Map();

function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1050;
                }
                .loading-modal-content {
                    background: white;
                    padding: 20px 40px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 0 10px rgba(0,0,0,0.25);
                }
            `}</style>
        </div>
    );
}

function Home() {
    const [funcionarios, setFuncionarios] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [pesquisa, setPesquisa] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [confirmacao, setConfirmacao] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');
    const [nome, setNome] = useState('');
    const [erro, setErro] = useState(false);
    const [status, setStatus] = useState('0');
    const [datahora, setData] = useState('');
    // Estado para foto + nome + chapa selecionados
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const navigate = useNavigate();
    const [codigorest, setCodigoRest] = useState(0);

    function MudarData() {
        const newdata = new Date().toLocaleTimeString();
        setData(newdata);
    }

    function atualizaRefeicao(chapa) {
        setConfirmacao(false);
        api.post('/restaurante/pedido/' + chapa)
            .then(() => {
                setFuncionarios(funcionarios.filter((t) => t.chapa !== chapa));
            })
            .catch((err) => {
                console.log("Erro na liberação: " + err);
                setLoading(false);
            });
    }

    function confirmDeleteUser(chapa, nome) {
        setConfirmacao(true);
        setConfirmacaoId(chapa);
        setNome(nome);
    }

    // Modificado: agora recebe também nome e chapa para mostrar no modal
    function abrirModalFoto(foto, nome, chapa) {
        setFotoSelecionada({ foto, nome, chapa });
    }

    useEffect(() => {
        const cod = localStorage.getItem("codigorest");
        if (cod) setCodigoRest(cod);
    }, []);

    useEffect(() => {
        if (!codigorest) return;
        api.get(`/restaurante/cadastro/${codigorest}`)
            .then(response => {
                const lojasExtraidas = response.data[0]?.lojas || [];
                setLojas(lojasExtraidas);
                
            })
            .catch(err => {
                console.log("Erro ao carregar lojas:", err);
            });
    }, [codigorest]);

    useEffect(() => {
        if (!codigorest) return;
        setLoading(true);
        setLoadingMessage('Aguarde... Consultando registros');
        setErro(false);

        api.get(`/restaurante/pedido/${codigorest}?loja=${pesquisa}&status=${status}`)
            .then(response => {
                const registros = response.data;
                setFuncionarios(registros.map(r => ({ ...r, foto: null })));
                setLoading(false);
                localStorage.setItem("codigorest",codigorest);
                console.log(localStorage.getItem("codigorest"))
                const hoje = new Date().toISOString().slice(0, 10);
                registros.forEach((funcionario) => {
                    if (fotosCache.has(funcionario.chapa)) {
                        const { data, foto } = fotosCache.get(funcionario.chapa);
                        if (data === hoje && foto) {
                            setFuncionarios(prev =>
                                prev.map(item =>
                                    item.chapa === funcionario.chapa ? { ...item, foto } : item
                                )
                            );
                            return;
                        }
                    }
                    api.get(`/usuario/foto/${funcionario.chapa}`)
                        .then(fotoResp => {
                            fotosCache.set(funcionario.chapa, { data: hoje, foto: fotoResp.data.foto });
                            setFuncionarios(prev =>
                                prev.map(item =>
                                    item.chapa === funcionario.chapa ? { ...item, foto: fotoResp.data.foto } : item
                                )
                            );
                        })
                        .catch(err => {
                            console.log(`Erro ao carregar foto da chapa ${funcionario.chapa}`, err);
                        });
                });
            })
            .catch(err => {
                console.log(err);
                setErro(true);
                setLoading(false);
            });
    }, [pesquisa, datahora, status, codigorest]);

    function handleGerarPDF() {
        setLoadingMessage('Aguarde... Gerando arquivo PDF');
        setLoading(true);
        Promise.resolve(RefeicaoPDF(funcionarios))
            .then(() => {
                setLoading(false);
            })
            .catch((err) => {
                console.log("Erro ao gerar PDF:", err);
                setLoading(false);
            });
    }

    return (
        <div>
            <Menu modulo="REST" />

            <LoadingModal show={loading} message={loadingMessage} />

            <div className="pagina-home">
                <div className="row row-filtro">
                    <button onClick={handleGerarPDF} className="col-2 btn btn-outline-secondary btn-filtro">
                        <i className="fa fa-file-pdf fa-1x fa-fw"></i> Gerar PDF
                    </button>
                    <button onClick={() => setStatus('0')} className="col-3 btn btn-outline-warning btn-filtro">
                        <i className="fa fa-spinner fa-spin fa-1x fa-fw"></i> Pendentes
                    </button>
                    <button onClick={() => setStatus('1')} className="col-3 btn btn-outline-success btn-filtro">
                        <i className="fa fa-check-square fa-fade"></i> Confirmadas
                    </button>
                    <button onClick={MudarData} className="col-3 btn btn-outline-danger btn-filtro">
                        <i className="fa fa-refresh fa-spin"></i> {datahora === "" ? "Aguardando" : `${datahora}`}
                    </button>
                </div>

                <div className="container-fluid">
                    <div className="row item">
                        <div className="col-3 sel-txt"><b>Loja: </b></div>
                        <div className="col-9">
                            <select
                                className="sel-item"
                                name="loja"
                                id="loja"
                                onChange={(e) => setPesquisa(e.target.value)}
                                value={pesquisa}
                            >
                                <option value="0">Todas</option>
                                {lojas.map(lj => (
                                    <option key={lj.loja} value={lj.loja}>{lj.loja}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="row g-1">
                        {funcionarios.map((tabela) => (
                            <div className="col-lg-2 col-md-12 col-sm-12 col-6" key={tabela.chapa}>
                                <CardPedido
                                    clickDelete={confirmDeleteUser}
                                    id={tabela.chapa}
                                    chapa={tabela.chapa}
                                    nome={tabela.nome}
                                    data={tabela.data}
                                    marmitex={tabela.marmitex}
                                    opcao={tabela.opcao}
                                    menu={tabela.menu}
                                    observacao={tabela.observacao}
                                    status={tabela.status}
                                    valor={tabela.valor}
                                    loja={tabela.loja}
                                    horasol={tabela.horasol}
                                    horaeft={tabela.horaeft}
                                    foto={tabela.foto}
                                    turno={tabela.turno}
                                    cor={tabela.chapa > 90000 ? '#66666633' : null}
                                    onFotoClick={() => abrirModalFoto(tabela.foto, tabela.nome, tabela.chapa)}
                                />
                            </div>
                        ))}
                        {funcionarios.length === 0 &&
                            <div className="no-item">Sem registros</div>
                        }
                    </div>

                    <Modal show={confirmacao} onHide={() => setConfirmacao(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmação</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Confirma a refeição de {nome}?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="danger" onClick={() => setConfirmacao(false)}>Não</Button>
                            <Button variant="success" onClick={() => atualizaRefeicao(confirmacaoId)}>Sim</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={erro} onHide={() => setErro(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Falha</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button variant="danger" onClick={() => setErro(false)}>OK</Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal foto em tela cheia com nome e chapa */}
                    <Modal show={!!fotoSelecionada} onHide={() => setFotoSelecionada(null)} centered size="lg">
                        <Modal.Body
                            className="modal-body-foto"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                gap: '10px', // espaço entre foto e texto
                            }}
                        >
                            {fotoSelecionada && (
                                <>
                                    <img
                                        src={`data:image/jpeg;base64,${fotoSelecionada.foto}`}
                                        alt="Foto"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '80vh',
                                            objectFit: 'contain',
                                            display: 'block', // evita inline que pode afetar alinhamento
                                        }}
                                    />
                                    <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                                        {fotoSelecionada.nome} ({fotoSelecionada.chapa})
                                    </div>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setFotoSelecionada(null)}>
                                Fechar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>

                {!loading && <Footer className="footer navbar-fixed-bottom" />}
            </div>
        </div>
    );
}

export default Home;
